export const contractAddress='0x68e8Ce06d84f5BF059cc18a1816819c3991C5EcB'

export const infura_RPC_URL_Polygon_Mainnet = 'https://polygon-mainnet.infura.io/v3/91c4e708571847948bb37155c7fd25fc'
export const infura_RPC_URL_Polygon_Mumbai = 'https://polygon-mumbai.infura.io/v3/91c4e708571847948bb37155c7fd25fc'
